import {createContext} from 'react'

const MainContext = createContext(null)

export default  MainContext
